import {handleActions} from 'redux-actions';
import actions from './notices.actions';
import uuidv4 from 'uuid/v4';

const reducer = handleActions(
	{
		[actions.noticesRequested]: (state, {payload}) => ({
			...state,
			communityUuid: payload
		}),
		[actions.noticesRetrieved]: (state, {payload}) => ({
			...state,
			items: payload
		}),
		[actions.noticesCommentAdded]: (state, {payload: {uuid, userUuid, newComment}}) => ({
			...state,
			items: state.items.map(item => {
				if (item.uuid === uuid) {
					return {
						...item, // Append the new comment to the state.
						comments: (item.comments || []).concat({
							userUuid,
							content: newComment
						})
					};
				} else {
					return item;
				}
			})
		}),
		[actions.noticesAdding]: (state, {payload}) => ({
			...state,
			adding: {
				uuid: uuidv4(),
				title: '',
				content: '',
				backgroundURL: '',
				communityUuid: state.communityUuid,
				userUuid: payload
			}
		}),
		[actions.noticesChangedAdding]: (state, {payload}) => ({
			...state,
			adding: {
				...state.adding,
				...payload
			}
		}),
		[actions.noticesDropBackgroundImgAdding]: (state, {payload}) => ({
			...state,
			adding: {
				...state.adding,
				image: payload.image,
				backgroundURL: payload.uuid
			}
		}),
		[actions.noticesAdded]: state => ({
			...state,
			items: state.items.concat(state.adding),
			adding: null
		}),
		[actions.noticesAddingCancelled]: state => ({
			...state,
			adding: null
		}),
		[actions.noticesEditing]: (state, {payload}) => ({
			...state,
			// Copy item when editing
			editing: {...state.items.find(n => n.uuid === payload)}
		}),
		[actions.noticesChangedEditing]: (state, {payload}) => ({
			...state,
			editing: {
				...state.editing,
				...payload
			}
		}),
		[actions.noticesDropBackgroundImgEditing]: (state, {payload}) => ({
			...state,
			editing: {
				...state.editing,
				image: payload.image,
				backgroundURL: payload.uuid
			}
		}),
		// Merge edited item back in to main state
		[actions.noticesEdited]: state => ({
			...state,
			items: state.items.map(n => {
				if (n.uuid === state.editing.uuid) {
					return {
						...n,
						...state.editing
					};
				} else {
					return n;
				}
			}),
			editing: null
		}),
		[actions.noticesEditedCancelled]: state => ({
			...state,
			editing: null
		}),
		[actions.noticesRemoved]: (state, {payload}) => ({
			...state,
			items: state.items.filter(n => n.uuid !== payload)
		})
	},
	{}
);

export default reducer;



// WEBPACK FOOTER //
// ./src/community/notices.reducer.js